<script setup lang="ts">
import PlaybookWizardStep from '@/components/playbooks/PlaybookWizardStep.vue';
</script>

<template>
  <PlaybookWizardStep step="extraction" />
</template>
